import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { createContext } from '../utils/create-context.ts';
import {
  selectionTagGroup,
  selectionTagGroupSize,
} from './selection-tag-group.css.ts';
import { type SelectionTagSize } from './selection-tag.css.ts';
import { SelectionTag } from './selection-tag.tsx';

const [SelectionTagGroupSizeProvider, useSelectionTagGroupSize] =
  createContext<SelectionTagSize>('SelectionTagGroupSize', 'md');

export type SelectionTagGroupProps = ComponentPropsWithRef<
  typeof ToggleGroupPrimitive.Root
> & {
  size?: SelectionTagSize;
};

export const SelectionTagGroup = ({
  ref,
  className,
  children,
  size = 'md',
  ...props
}: SelectionTagGroupProps) => {
  return (
    <SelectionTagGroupSizeProvider value={size}>
      <ToggleGroupPrimitive.Root
        ref={ref}
        className={clsx(
          selectionTagGroup,
          selectionTagGroupSize[size],
          className,
        )}
        {...props}
      >
        {children}
      </ToggleGroupPrimitive.Root>
    </SelectionTagGroupSizeProvider>
  );
};

export type SelectionTagGroupItemProps = Omit<
  ComponentPropsWithRef<typeof ToggleGroupPrimitive.Item>,
  'asChild'
> & {
  size?: SelectionTagSize;
};

export const SelectionTagGroupItem = ({
  ref,
  className,
  children,
  size,
  ...props
}: SelectionTagGroupItemProps) => {
  const groupSize = useSelectionTagGroupSize();
  return (
    <ToggleGroupPrimitive.Item
      ref={ref}
      className={className}
      {...props}
      asChild
    >
      <SelectionTag size={size ?? groupSize}>{children}</SelectionTag>
    </ToggleGroupPrimitive.Item>
  );
};
